import { render, staticRenderFns } from "./dataMonitor.vue?vue&type=template&id=b9ba4912&scoped=true"
import script from "./dataMonitor.vue?vue&type=script&lang=js"
export * from "./dataMonitor.vue?vue&type=script&lang=js"
import style0 from "./dataMonitor.vue?vue&type=style&index=0&id=b9ba4912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ba4912",
  null
  
)

export default component.exports